// Parses a backend timestamp into a Date representing the correct instant,
// for display in the user's local timezone. Defensive against three real
// API quirks seen in production: (1) some timestamps already carry a
// timezone designator (Z or +hh:mm) while others don't, so blindly
// appending 'Z' double-applies a zone and produces "Invalid Date";
// (2) some timestamps omit leading zeros (e.g. "2024-1-5T9:3:7"), which
// also fails native Date parsing; (3) some (raw .NET/SQL DateTime
// serialization) use a space instead of 'T' between date and time
// (e.g. "2024-01-15 10:30:00.000"), which also fails strict ISO parsing.
export function parseApiDate(dateTime: string | number | Date): Date | null {
  if (!dateTime) return null;

  if (typeof dateTime !== 'string') {
    const date = new Date(dateTime);
    return isNaN(date.getTime()) ? null : date;
  }

  const normalized = dateTime.replace(
    /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T ](\d{1,2}):(\d{1,2}):(\d{1,2}))?/,
    (_match, y, mo, d, h = '00', mi = '00', s = '00') =>
      `${y}-${mo.padStart(2, '0')}-${d.padStart(2, '0')}T${h.padStart(2, '0')}:${mi.padStart(2, '0')}:${s.padStart(2, '0')}`
  );
  const hasZone = /Z$|[+-]\d{2}:?\d{2}$/.test(normalized);
  const date = new Date(hasZone ? normalized : normalized + 'Z');

  return isNaN(date.getTime()) ? null : date;
}
